import { useContext, useEffect } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Popper from '@mui/material/Popper';
import type { PopupState } from 'material-ui-popup-state/hooks';
import { bindPopper } from 'material-ui-popup-state/hooks';
import { WorkspaceGlobalSearchBarResetContext, WorkspaceGlobalSearchBarQueryContext } from './Context';
import Filters from './Filters';
import Form from './Form';
import Results from './Results';
import styles from './style.module.css';

export default function PopperContent({ popupState }: PopperContentProps) {
  const { clickedAwayReset } = useContext(WorkspaceGlobalSearchBarResetContext);
  const { barRefs, query } = useContext(WorkspaceGlobalSearchBarQueryContext);

  useEffect(() => {
    if (barRefs.current.form && popupState.anchorEl !== barRefs.current.form) {
      popupState.setAnchorEl(barRefs.current.form);
    }
  }, [popupState, barRefs]);

  return (
    <ClickAwayListener onClickAway={clickedAwayReset}>
      <div>
        <Form />
        <Popper
          {...bindPopper(popupState)}
          placement="bottom-start"
          modifiers={[{
            name: 'offset',
            options: {
              offset: [0, 10],
            },
          }]}>
          {!!query.length && <div className={styles.container}>
            <div className={styles.content}>
              <div className={styles.results}>
                <Results />
              </div>
              <Filters />
            </div>
          </div>}
        </Popper>
      </div>
    </ClickAwayListener>
  );
}

export { PopperContent as Popper };

type PopperContentProps = {
  popupState: PopupState;
};